var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.type === 'audio')?_c('audio-step',_vm._g({attrs:{"data":_vm.data}},_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }